import { createFileRoute, redirect } from '@tanstack/react-router';

/*
 * La coda «Approvazioni prenotazioni» è stata tolta il 23-10-2026: leggeva lo stato vecchio
 * (`ManagerApproval`, `GET /api/bookings/pending-approval-for-me`), che il flusso nuovo non
 * scrive mai — ci restavano anche le richieste già approvate. Le code vere stanno in
 * «Approvazioni», schede Mezzi, Trasferte e Sale riunioni. Qui restano vivi i vecchi link.
 */
export const Route = createFileRoute('/_app/instruments-calendar/approvals')({
  beforeLoad: () => { throw redirect({ to: '/approvals', search: { tab: 'vehicle' }, replace: true }); },
});
